import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

const PublicSessionContext = createContext(undefined);

/**
 * Compatibility surface for product components that only need basic account
 * details. The canonical session, profile and auth actions all come from the
 * single application-wide AuthProvider.
 */
export function PublicSessionProvider({ children }) {
  const {
    user,
    profile,
    loading,
    signInWithGoogle,
    signOut,
  } = useAuth();

  const value = useMemo(() => ({
    user,
    profile,
    loading,
    signInWithGoogle,
    signOut,
  }), [loading, profile, signInWithGoogle, signOut, user]);

  return (
    <PublicSessionContext.Provider value={value}>
      {children}
    </PublicSessionContext.Provider>
  );
}

export function usePublicSession() {
  const context = useContext(PublicSessionContext);

  if (context === undefined) {
    throw new Error('usePublicSession must be used within a PublicSessionProvider');
  }

  return context;
}
